export default "__VITE_ASSET__DVoGdn1x__"